import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const StaticIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 16 16"
         fill="none"
         {...props}
      >
         <path
            d="M0.75 0.704102C1.16562 0.704102 1.5 1.03848 1.5 1.4541L1.5 12.4541C1.5 12.8697 1.83438 13.2041 2.25 13.2041L15.25 13.2041C15.6656 13.2041 16 13.5385 16 13.9541C16 14.3697 15.6656 14.7041 15.25 14.7041L2.25 14.7041C1.00625 14.7041 0 13.6979 0 12.4541L0 1.4541C0 1.03848 0.334375 0.704102 0.75 0.704102ZM4 3.9541C4 3.53848 4.33437 3.2041 4.75 3.2041L11.25 3.2041C11.6656 3.2041 12 3.53848 12 3.9541C12 4.36973 11.6656 4.7041 11.25 4.7041L4.75 4.7041C4.33437 4.7041 4 4.36973 4 3.9541ZM4.75 6.2041H9.25C9.66562 6.2041 10 6.53848 10 6.9541C10 7.36973 9.66562 7.7041 9.25 7.7041H4.75C4.33437 7.7041 4 7.36973 4 6.9541C4 6.53848 4.33437 6.2041 4.75 6.2041ZM4.75 9.2041L13.25 9.2041C13.6656 9.2041 14 9.53848 14 9.9541C14 10.3697 13.6656 10.7041 13.25 10.7041L4.75 10.7041C4.33437 10.7041 4 10.3697 4 9.9541C4 9.53848 4.33437 9.2041 4.75 9.2041Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default StaticIcon
